// extracted by mini-css-extract-plugin
export var base = "ImagePreview-module--base--6d2ea";
export var visible = "ImagePreview-module--visible--eac9a";